import { Input } from '@/components/ui/input';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { Search } from 'lucide-react';
import { useLanguage } from '@/i18n/LanguageContext';

export const UserFiltersBar = ({
  search, setSearch,
  roleFilter, setRoleFilter,
  sortBy, setSortBy,
  resultsCount, totalCount,
}) => {
  const { t } = useLanguage();
  return (
    <div className="bg-card border border-border rounded-sm p-4 mb-6 flex flex-col md:flex-row gap-3 md:items-center">
      <div className="relative flex-1 min-w-[200px]">
        <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-muted-foreground" />
        <Input
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          placeholder={t('users.searchPlaceholder')}
          className="pl-9 bg-background border-border"
          data-testid="user-search-input"
        />
      </div>

      <Select value={roleFilter} onValueChange={setRoleFilter}>
        <SelectTrigger className="w-[160px] bg-background border-border" data-testid="user-role-filter">
          <SelectValue placeholder={t('users.filterRole')} />
        </SelectTrigger>
        <SelectContent className="bg-card border-border">
          <SelectItem value="all">{t('users.allRoles')}</SelectItem>
          <SelectItem value="admin">{t('users.roleAdmin')}</SelectItem>
          <SelectItem value="teacher">{t('users.roleTeacher')}</SelectItem>
          <SelectItem value="parent">{t('users.roleParent')}</SelectItem>
        </SelectContent>
      </Select>

      <Select value={sortBy} onValueChange={setSortBy}>
        <SelectTrigger className="w-[180px] bg-background border-border" data-testid="user-sort">
          <SelectValue placeholder={t('users.sortBy')} />
        </SelectTrigger>
        <SelectContent className="bg-card border-border">
          <SelectItem value="newest">{t('users.sortNewest')}</SelectItem>
          <SelectItem value="oldest">{t('users.sortOldest')}</SelectItem>
          <SelectItem value="name_az">{t('users.sortNameAZ')}</SelectItem>
          <SelectItem value="name_za">{t('users.sortNameZA')}</SelectItem>
          <SelectItem value="email">{t('users.sortEmail')}</SelectItem>
          <SelectItem value="role">{t('users.sortRole')}</SelectItem>
        </SelectContent>
      </Select>

      <p className="text-xs text-muted-foreground whitespace-nowrap" data-testid="user-results-count">
        {t('users.resultsCount').replace('{n}', resultsCount).replace('{total}', totalCount)}
      </p>
    </div>
  );
};
